import {
  Checkbox,
  CircularProgress,
  Divider,
  Grid,
  LinearProgress,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useEffect, useState, Activity } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AddDepartment from 'components/shared/AddDepartment';
import { addDepartments } from 'queries/departmentQueries';
import { sendCustomEmail } from 'queries/emailQueries';
import { ErrorAlert } from '../../components/atoms/Alert-message';
import Button from '../../components/atoms/button';
import FileUpload from '../../components/atoms/file-upload';
import InputTextAreaField from '../../components/atoms/input-field/inputTextAreaField';
import InputTextField from '../../components/atoms/input-field/inputTextField';
import PickDate from '../../components/atoms/pick-date';
import Toast, {
  showToasterFailure,
  showToasterSuccess,
} from '../../components/atoms/toast';
import CreatorFiles from '../../components/files/CreatorFiles';
import OwnerFiles from '../../components/files/OwnerFiles';
import { default as CustomButton } from '../../components/shared/Button';
import { APIHeader, APIHeaderForUpload } from '../../index';
import { errorNotification } from '../../reducers/handle-api-status/slice';
import {
  boldFont,
  buttonCircularProgress,
  checkboxLabel,
  commentStyle,
  costImpactdisplayFiles,
  costImpactHeader,
  costImpactMain,
  costImpactValueGrid,
  height30px,
  homeButtonComponent,
  LocalSiteButtons,
  OwnerLSCComment,
  ownerLSCInput,
  OwnerlscValue,
  progressBar,
  ReviewDoneMessage,
  SiteReviewTitle,
  SiteReviewValue,
  TextAsLink,
  titleName,
  UploadedBy,
  UploadedDocument,
  uploadedFilesGrid,
  validationErrorOnPages,
} from '../../styles';
import {
  getDownloadLink,
  getURL,
  includeNegativeForCostImpact,
  keyMapper,
  stripTrailingSlash,
  validateInputFields,
} from '../../utils';

const OwnerLSCReview = props => {
  const { apiConfig, userInfo, errorInAPI } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const urlInfo = stripTrailingSlash(window.location.toString()).split('/');
  const siteId = urlInfo.pop();
  const pecrId = urlInfo.pop();
  const url = getURL();

  const [estimateData, setEstimateData] = useState([]);
  const [fetchedFiles, setFetchedFiles] = useState([]);
  const [selectedCheckbox, setSelectedCheckbox] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [isHold, setIsHold] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [displayFiles, setDisplayFiles] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [showProgress, setShowProgress] = useState(false);
  const [inputValidationMessage, setInputValidationMessage] = useState('');
  const [showSaveProgress, setShowSaveProgress] = useState(false);
  const [showAddDepartment, setShowAddDepartment] = useState(false);
  const [selectedDepartments, setSelectedDepartments] = useState({});
  const [refetchTrigger, setRefetchTrigger] = useState(0);

  const { mutateAsync } = useMutation({
    mutationFn: addDepartments,
    onSuccess: () => {
      setShowAddDepartment(false);
      setRefetchTrigger(prev => prev + 1);
    },
    onError: error => {
      console.error('Error adding departments: ', error);
      dispatch(
        errorNotification({
          hasErrorOccured: true,
          message: t('error_message'),
        })
      );
    },
  });
  const { mutateAsync: sendCustomEmailMutation } = useMutation({
    mutationFn: sendCustomEmail,
    onError: error => {
      console.error('Error sending email:', error);
      dispatch(
        errorNotification({
          hasErrorOccured: true,
          message: t('error_message'),
        })
      );
    },
  });

  useEffect(() => {
    if ((pecrId, siteId)) {
      fetch(`${apiConfig.uiURL}api/FetchAllDepartmentStatus`, {
        method: 'POST',
        headers: APIHeader(),
        body: JSON.stringify({
          pecrId: pecrId,
          siteId: siteId,
        }),
      })
        .then(async response => {
          const data = await response.json();
          setEstimateData(data);
          data.map(async item => {
            const response = await fetch(
              `${apiConfig.uiURL}api/FetchFilesFromDepartment`,
              {
                method: 'POST',
                headers: APIHeader(),
                body: JSON.stringify({
                  MainFolder: 'PECROverview',
                  SubFolder: item.PECR_ID,
                  siteId: item.SiteID,
                  departmentId: item.DeptId,
                  index: item.EDIndex,
                }),
              }
            ).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            });

            if (data.length > 0) {
              //Fetch Files from Folder based on Cost Impact
              fetch(`${apiConfig.uiURL}api/FetchFilesForCostImpact`, {
                method: 'POST',
                headers: APIHeader(),
                body: JSON.stringify({
                  MainFolder: 'PECROverview',
                  SubFolder: pecrId,
                  siteId: siteId,
                  costImpact: 'CostImpact',
                }),
              })
                .then(async response => {
                  const files = await response.json();
                  setDisplayFiles(files);
                })
                .catch(() => {
                  dispatch(
                    errorNotification({
                      hasErrorOccured: true,
                      message: t('error_message'),
                    })
                  );
                });
            }

            const data2 = await response.json();
            setFetchedFiles(prevState => [
              ...prevState,
              {
                documents: data2,
                departmentId: item.DeptId,
                index: item.EDIndex,
              },
            ]);
          });
          if (
            data.length > 0 &&
            (data[0].SCStatus === 9 ||
              data[0].SCStatus === 14 ||
              data[0].SCStatus === 13)
          ) {
            setDisabled(true);
          } else {
            setDisabled(false);
          }

          if (data.length > 0 && data[0].SCStatus === 9) {
            setIsHold(true);
          } else {
            setIsHold(false);
          }
        })
        .catch(() => {
          dispatch(
            errorNotification({
              hasErrorOccured: true,
              message: t('error_message'),
            })
          );
        });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pecrId, siteId, apiConfig, refetchTrigger]);

  useEffect(() => {
    const finalData = estimateData.map(item => {
      const item2 = fetchedFiles.find(
        value =>
          value.departmentId === item.DeptId && value.index === item.EDIndex
      );
      return item2 ? { ...item, Doc: item2.documents } : item;
    });

    setEstimateData(finalData);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchedFiles]);

  //To handle the onChange event of all updates
  const handleOnChange = (key, event) => {
    const setDataValue = value => {
      const newEstimateData = [...estimateData];
      newEstimateData[0][key] = value;
      setEstimateData(newEstimateData);
    };
    if (key === 'OwnerLSCComments') {
      const eventValue = event.target.value.trim();
      setDataValue(eventValue);
      const ValidationMessage = validateInputFields(eventValue, t);
      setInputValidationMessage(ValidationMessage);
    } else {
      setDataValue(event.target.value);
    }
  };

  const disableGCExecuteButton =
    estimateData.length > 0 &&
    (estimateData[0].CostImpactOnProducts === '' ||
      estimateData[0].CostImpactOnProducts === null ||
      estimateData[0].OwnerLSCComments === '' ||
      estimateData[0].OwnerLSCComments === null ||
      (Number(estimateData[0].CostImpactOnProducts) !== 0 &&
        displayFiles.length === 0));
  //To handle the selected department's checkboxes for new estimations
  const handleCheckboxChange = data => {
    const list = [...selectedCheckbox];
    const index = list.map(item => item.Dept).indexOf(data.Dept);
    index === -1 ? list.push(data) : list.splice(index, 1);
    setSelectedCheckbox(list);
  };

  const formattedDate =
    selectedDate === null ? null : selectedDate.format('MMM DD, YYYY');

  const targetDate =
    formattedDate || (estimateData.length > 0 && estimateData[0].TargetDate);

  const disableGCButton =
    estimateData.length > 0 &&
    estimateData.every(item => {
      return item.Status !== null;
    });

  const notImapctedDepartments =
    estimateData.length > 0 &&
    estimateData.filter(item => item.StatusName === 'Not Impacted');
  //To filter the estimated departments
  const estimatedDepartment =
    estimateData.length > 0 &&
    estimateData.filter(item => {
      return item.StatusName === 'Estimated';
    });

  //To handle the deletion of uploaded document
  const removeDoc = (event, fileName) => {
    event.preventDefault();
    const remainingFile = displayFiles.filter(file => {
      return file !== fileName;
    });
    setDisplayFiles(remainingFile);
    const remainingUploadFile = uploadedFiles.filter(file => {
      return file.name !== fileName;
    });
    setUploadedFiles(remainingUploadFile);
    fetch(`${apiConfig.uiURL}api/DeleteFile`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        MainFolder: 'PECROverview',
        SubFolder: pecrId,
        siteId: siteId,
        fileName: fileName,
        PID: pecrId,
        folderName: 'CostImpact',
        email: userInfo.userEmail,
        phase: 'CostImpact',
      }),
    }).catch(() => {
      dispatch(
        errorNotification({
          hasErrorOccured: true,
          message: t('error_message'),
        })
      );
    });
    setErrorMessage('');
  };

  const onProvideNewEstimatesClick = () => {
    selectedCheckbox.forEach(selectedDepartment => {
      fetch(`${apiConfig.uiURL}api/UpdateEstimation`, {
        method: 'POST',
        headers: APIHeader(),
        body: JSON.stringify({
          pecrId: selectedDepartment.PECR_ID,
          siteId: selectedDepartment.SiteID,
          departmentId: selectedDepartment.DeptId,
          EIndex: selectedDepartment.EDIndex,
          UserId: selectedDepartment.EstimatedUserId,
          EstimateEffort: selectedDepartment.EstimatedEffort,
          EstimateCost: selectedDepartment.EstimatedCost,
          Currency: selectedDepartment.CurrencyUnit,
          Comments: selectedDepartment.EstimatedComment,
          Label: selectedDepartment.Label,
        }),
      })
        .then(async res => {
          const response = await res.json();
          return (
            fetch(`${apiConfig.uiURL}api/InsertEstimationForSC`, {
              method: 'POST',
              headers: APIHeader(),
              body: JSON.stringify({
                pecrId: pecrId,
                siteId: siteId,
                Status: response[0].FinalStaus,
                TotalEffort: response[0].TotalEffort,
                TotalCost: response[0].TotalCost,
                reviwerId: selectedDepartment.CoordinatorID,
                GlobalCoordinatorID: selectedDepartment.GlobalCoordinatorID,
              }),
            }).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            }),
            //sendEmail to each lead
            fetch(`${apiConfig.uiURL}api/sendEmail`, {
              headers: APIHeader(),
              method: 'POST',
              body: JSON.stringify({
                PecrId: pecrId,
                toAddress: selectedDepartment.LeadEmail,
                loginUserEmail: userInfo.userEmail,
                Title: selectedDepartment.Title,
                toWhome: 'Estimation Dept Lead for New Estimation',
                Comments:
                  estimateData &&
                  estimateData.length > 0 &&
                  estimateData[0].OwnerLSCComments
                    ? estimateData[0].OwnerLSCComments
                    : '',
                Departments: selectedDepartment.Dept,
                Description: selectedDepartment.Description,
                fromAddress: 'PECR@carrier.com',
                type: 'assignEmail',
                URL: `${url}Department/${selectedDepartment.PECR_ID}/${selectedDepartment.SiteID}/${selectedDepartment.DeptId}/${selectedDepartment.EDIndex}`,
                Factory: selectedDepartment.SiteName,
                creatorsite:
                  estimateData &&
                  estimateData[0] &&
                  estimateData[0].CreatorSiteName
                    ? estimateData[0].CreatorSiteName
                    : '',
                creator: `${
                  estimateData &&
                  estimateData[0] &&
                  estimateData[0].CreatorFirstName
                    ? estimateData[0].CreatorFirstName
                    : ''
                } ${
                  estimateData &&
                  estimateData[0] &&
                  estimateData[0].CreatorLastName
                    ? estimateData[0].CreatorLastName
                    : ''
                }`,
              }),
            }).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            })
          );
        })
        .catch(() => {
          dispatch(
            errorNotification({
              hasErrorOccured: true,
              message: t('error_message'),
            })
          );
        });
    });
    //Navigate to home page
    navigate('../');
  };

  function onAddNewDepartment() {
    setShowAddDepartment(true);
  }

  function getEmailsForReject(data) {
    const emails = [];
    data[0]?.CreatorEmail && emails.push(data[0].CreatorEmail);
    data[0]?.OwnerEmail && emails.push(data[0].OwnerEmail);
    data.forEach(item => {
      emails.push(item.LeadEmail);
    });
    return Array.from(new Set(emails));
  }
  const onRejectClick = () => {
    if (!estimateData || !estimateData[0]) {
      return;
    }
    fetch(`${apiConfig.uiURL}api/InsertEstimationForSC`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        pecrId: pecrId,
        siteId: siteId,
        reviwerId:
          estimateData && estimateData[0].CoordinatorID
            ? estimateData[0].CoordinatorID
            : null,
        GlobalCoordinatorID:
          estimateData && estimateData[0].GlobalCoordinatorID
            ? estimateData[0].GlobalCoordinatorID
            : null,
        Status: 14,
        TotalEffort:
          estimateData && estimateData[0].TotalEffort
            ? estimateData[0].TotalEffort
            : null,
        TotalCost:
          estimateData && estimateData[0].TotalCost
            ? estimateData[0].TotalCost
            : null,
        comments: estimateData[0].OwnerLSCComments,
      }),
    })
      .then(async _res => {
        const emails = getEmailsForReject(estimateData);

        return (
          //send Emails for rejection
          (
            fetch(`${apiConfig.uiURL}api/sendEmail`, {
              headers: APIHeader(),
              method: 'POST',
              body: JSON.stringify({
                PecrId: pecrId,
                toAddress: emails,
                loginUserEmail: userInfo.userEmail,
                Title: estimateData?.[0]?.Title ?? null,
                toWhome: 'Estimation SC Reject',
                Comments: estimateData?.[0]?.OwnerLSCComments ?? '',
                Description: estimateData?.[0]?.Description ?? null,
                fromAddress: 'PECR@carrier.com',
                type: 'assignEmail',
                Factory: estimateData?.[0]?.SiteName ?? null,
                creatorsite: estimateData?.[0]?.CreatorSiteName ?? '',
                creator: `${estimateData?.[0]?.CreatorFirstName ?? ''} ${estimateData?.[0]?.CreatorLastName ?? ''}`,
              }),
            }).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            }),
            navigate('../')
          )
        );
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };

  const onUnHoldClick = () => {
    fetch(`${apiConfig.uiURL}api/InsertEstimationForSC`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        pecrId: pecrId,
        siteId: siteId,
        reviwerId: estimateData?.[0]?.CoordinatorID ?? null,
        GlobalCoordinatorID: estimateData?.[0]?.GlobalCoordinatorID ?? null,
        Status: 9,
        TotalEffort: estimateData?.[0]?.TotalEffort ?? null,
        TotalCost: estimateData?.[0]?.TotalCost ?? null,
        comments: '',
      }),
    })
      .then(() => {
        //Navigate to Home Page
        navigate('../');
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };
  const onHoldClick = () => {
    fetch(`${apiConfig.uiURL}api/InsertEstimationForSC`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        pecrId: pecrId,
        siteId: siteId,
        reviwerId: estimateData?.[0]?.CoordinatorID ?? null,
        GlobalCoordinatorID: estimateData?.[0]?.GlobalCoordinatorID ?? null,
        Status: 9,
        TotalEffort: estimateData?.[0]?.TotalEffort ?? null,
        TotalCost: estimateData?.[0]?.TotalCost ?? null,
        comments: estimateData?.[0]?.OwnerLSCComments ?? '',
      }),
    })
      .then(async res => {
        return (
          //send Email to creator
          (
            fetch(`${apiConfig.uiURL}api/sendEmail`, {
              headers: APIHeader(),
              method: 'POST',
              body: JSON.stringify({
                PecrId: pecrId,
                toAddress: estimateData?.[0]?.CreatorEmail ?? null,
                loginUserEmail: userInfo.userEmail,
                Title: estimateData?.[0]?.Title ?? null,
                toWhome: 'Estimation SC Hold',
                Comments: estimateData?.[0]?.OwnerLSCComments ?? '',
                Description: estimateData?.[0]?.Description ?? null,
                fromAddress: 'PECR@carrier.com',
                type: 'assignEmail',
                Factory: estimateData?.[0]?.SiteName ?? null,
                creatorsite: estimateData?.[0]?.CreatorSiteName ?? null,
                creator: `${estimateData?.[0]?.CreatorFirstName ?? ''} ${estimateData?.[0]?.CreatorLastName ?? ''}`,
              }),
            }).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            }),
            //send Email to owner
            fetch(`${apiConfig.uiURL}api/sendEmail`, {
              headers: APIHeader(),
              method: 'POST',
              body: JSON.stringify({
                PecrId: pecrId,
                toAddress: estimateData?.[0]?.OwnerEmail ?? null,
                loginUserEmail: userInfo.userEmail,
                Title: estimateData?.[0]?.Title ?? null,
                toWhome: 'Estimation SC Hold',
                Comments: estimateData?.[0]?.OwnerLSCComments ?? '',
                Description: estimateData?.[0]?.Description ?? null,
                fromAddress: 'PECR@carrier.com',
                type: 'assignEmail',
                Factory: estimateData?.[0]?.SiteName ?? null,
                creatorsite: estimateData?.[0]?.CreatorSiteName ?? null,
                creator: `${estimateData?.[0]?.CreatorFirstName ?? ''} ${
                  estimateData?.[0]?.CreatorLastName ?? ''
                }`,
              }),
            }).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            }),
            //send Email to each Lead
            estimateData &&
              estimateData.forEach(item => {
                fetch(`${apiConfig.uiURL}api/sendEmail`, {
                  headers: APIHeader(),
                  method: 'POST',
                  body: JSON.stringify({
                    PecrId: pecrId,
                    toAddress: item.LeadEmail,
                    loginUserEmail: userInfo.userEmail,
                    Title: item.Title ?? '',
                    toWhome: 'Estimation SC Hold',
                    Comments: estimateData?.[0]?.OwnerLSCComments ?? '',
                    Description: item.Description,
                    fromAddress: 'PECR@carrier.com',
                    type: 'assignEmail',
                    Factory: item.SiteName,
                    creatorsite: item.CreatorSiteName,
                    creator: `${item.CreatorFirstName} ${item.CreatorLastName}`,
                  }),
                }).catch(() => {
                  dispatch(
                    errorNotification({
                      hasErrorOccured: true,
                      message: t('error_message'),
                    })
                  );
                });
              }),
            //navigate to Home Page
            navigate('../')
          )
        );
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };

  //To upload the files in folder for CostImpact
  const uploadDocument = (isApproveButtonClicked = false) => {
    setShowProgress(true);
    const uploadData = new FormData();
    for (const file of uploadedFiles) {
      uploadData.append('file', file);
    }
    uploadData.append('MainFolder', 'PECROverview');
    uploadData.append('SubFolder', pecrId);
    uploadData.append('siteId', siteId);
    uploadData.append('costImpact', 'CostImpact');

    // API call to upload the document
    fetch(`${apiConfig.uiURL}api/uploadDocForCostImpact`, {
      headers: APIHeaderForUpload(),
      method: 'POST',
      body: uploadData,
    })
      .then(async res => {
        if (res.status === 200) {
          //stop showing progress bar
          setShowProgress(false);
          setShowSaveProgress(false);
          //navigate to Home page if Approve button clicked
          isApproveButtonClicked && navigate('../');
        }
      })
      .catch(() => {
        setShowProgress(false);
        setShowSaveProgress(false);
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };

  //To handle the onClick of Save button
  const onSaveClick = () => {
    setShowSaveProgress(true);
    const updateData = fetch(`${apiConfig.uiURL}api/InsertEstimationForSC`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        pecrId: pecrId,
        siteId: siteId,
        reviwerId: estimateData?.[0]?.CoordinatorID ?? null,
        GlobalCoordinatorID: estimateData?.[0]?.GlobalCoordinatorID ?? null,
        Status: 10,
        TotalEffort: estimateData?.[0]?.TotalEffort ?? null,
        TotalCost: estimateData?.[0]?.TotalCost ?? null,
        comments: estimateData?.[0]?.OwnerLSCComments ?? '',
        TargetDate: targetDate,
        CostImpact: estimateData?.[0]?.CostImpactOnProducts ?? null,
      }),
    }).then(async () => {
      //call uploadDocument function to upload the file
      uploadDocument();
    });
    Promise.all([updateData])
      .then(() => {
        showToasterSuccess(t('Save_message'));
      })
      .catch(() => {
        showToasterFailure(t('Save_failed_message'));
      });
  };

  const onSubmitToGCClick = () => {
    fetch(`${apiConfig.uiURL}api/InsertEstimationForSC`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        pecrId: pecrId,
        siteId: siteId,
        reviwerId: estimateData?.[0]?.CoordinatorID ?? null,
        GlobalCoordinatorID: estimateData?.[0]?.GlobalCoordinatorID ?? null,
        Status: 13,
        TotalEffort: estimateData?.[0]?.TotalEffort ?? null,
        TotalCost: estimateData?.[0]?.TotalCost ?? null,
        comments: estimateData?.[0]?.OwnerLSCComments ?? '',
        TargetDate: targetDate,
        CostImpact: estimateData?.[0]?.CostImpactOnProducts ?? null,
      }),
    })
      .then(async res => {
        return (
          //send Email to owner
          (
            fetch(`${apiConfig.uiURL}api/sendEmail`, {
              headers: APIHeader(),
              method: 'POST',
              body: JSON.stringify({
                PecrId: pecrId,
                toAddress: estimateData?.[0]?.OwnerEmail ?? null,
                loginUserEmail: userInfo.userEmail,
                Title: estimateData?.[0]?.Title ?? null,
                toWhome: 'Submit to Global Coordinator-Owner',
                Comments: estimateData?.[0]?.OwnerLSCComments ?? '',
                Description: estimateData?.[0]?.Description ?? null,
                fromAddress: 'PECR@carrier.com',
                type: 'assignEmail',
                Factory: estimateData?.[0]?.SiteName ?? null,
                creatorsite: estimateData?.[0]?.CreatorSiteName ?? '',
                creator: `${estimateData?.[0]?.CreatorFirstName ?? ''} ${
                  estimateData?.[0]?.CreatorLastName ?? ''
                }`,
              }),
            }).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            }),
            //send Email to global Coordinator
            fetch(`${apiConfig.uiURL}api/sendEmail`, {
              headers: APIHeader(),
              method: 'POST',
              body: JSON.stringify({
                PecrId: pecrId,
                toAddress: estimateData?.[0]?.GlobalCoordinator ?? null,
                loginUserEmail: userInfo.userEmail,
                Title: estimateData?.[0]?.Title ?? null,
                toWhome: 'Submit to Global Coordinator',
                Comments: estimateData?.[0]?.OwnerLSCComments ?? '',
                Description: estimateData?.[0]?.Description ?? null,
                URL: `${url}GlobalCoordinatorReview/${pecrId}`,
                fromAddress: 'PECR@carrier.com',
                type: 'assignEmail',
                Factory: estimateData?.[0]?.SiteName ?? null,
                creatorsite: estimateData?.[0]?.CreatorSiteName ?? '',
                creator: `${estimateData?.[0]?.CreatorFirstName ?? ''} ${
                  estimateData?.[0]?.CreatorLastName ?? ''
                }`,
              }),
            }).catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            }),
            uploadDocument(true)
          )
        );
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };
  const onExecuteClick = () => {
    fetch(`${apiConfig.uiURL}api/InsertEstimationForSC`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        pecrId: pecrId,
        siteId: siteId,
        reviwerId: estimateData?.[0]?.CoordinatorID ?? null,
        GlobalCoordinatorID: estimateData?.[0]?.GlobalCoordinatorID ?? null,
        Status: 13,
        TotalEffort: estimateData?.[0]?.TotalEffort ?? null,
        TotalCost: estimateData?.[0]?.TotalCost ?? null,
        comments: estimateData?.[0]?.OwnerLSCComments ?? '',
        TargetDate: targetDate,
        CostImpact: estimateData?.[0]?.CostImpactOnProducts ?? null,
      }),
    })
      .then(async res => {
        return (
          //Update Global Coordinator Review, because single site will not go on Global Coordinator page
          fetch(`${apiConfig.uiURL}api/UpdateGlobalCoordinatorReview`, {
            method: 'PUT',
            headers: APIHeader(),
            body: JSON.stringify({
              pecrId: pecrId,
              siteId: siteId,
              Comments: estimateData?.[0]?.OwnerLSCComments ?? '',
              StatusId: 12,
              ButtonStatus: 4,
              TargetDate: targetDate,
              CostImpact: estimateData?.[0]?.CostImpactOnProducts ?? null,
            }),
          })
            .then(() => {
              return (
                //Send Email to creator
                (
                  fetch(`${apiConfig.uiURL}api/sendEmail`, {
                    headers: APIHeader(),
                    method: 'POST',
                    body: JSON.stringify({
                      toAddress: estimateData?.[0]?.CreatorEmail ?? '',
                      fromAddress: 'PECR@carrier.com',
                      loginUserEmail: userInfo.userEmail,
                      Title: estimateData?.[0]?.Title ?? '',
                      PecrId: pecrId,
                      type: 'assignEmail',
                      toWhome: 'GC All Sites Creator',
                      Comments: estimateData?.[0]?.OwnerLSCComments ?? '',
                      Factory: estimateData?.[0]?.SiteName ?? '',
                      creatorsite: estimateData?.[0]?.CreatorSiteName ?? '',
                      creator: `${estimateData?.[0]?.CreatorFirstName ?? ''} ${
                        estimateData?.[0]?.CreatorLastName ?? ''
                      }`,
                    }),
                  }).catch(() => {
                    dispatch(
                      errorNotification({
                        hasErrorOccured: true,
                        message: t('error_message'),
                      })
                    );
                  }),
                  //Send Email to each owner
                  fetch(`${apiConfig.uiURL}api/sendEmail`, {
                    headers: APIHeader(),
                    method: 'POST',
                    body: JSON.stringify({
                      toAddress: estimateData?.[0]?.OwnerEmail ?? '',
                      fromAddress: 'PECR@carrier.com',
                      loginUserEmail: userInfo.userEmail,
                      Title: estimateData?.[0]?.Title ?? '',
                      PecrId: pecrId,
                      type: 'assignEmail',
                      Factory: estimateData?.[0]?.SiteName ?? '',
                      toWhome: 'GC All Sites Owner',
                      Comments: estimateData?.[0]?.OwnerLSCComments ?? '',
                      Departments:
                        estimatedDepartment.length > 0 &&
                        keyMapper(estimatedDepartment, 'Dept'),
                      creatorsite: estimateData?.[0]?.CreatorSiteName ?? '',
                      creator: `${estimateData?.[0]?.CreatorFirstName ?? ''} ${estimateData?.[0]?.CreatorLastName ?? ''}`,
                    }),
                  }).catch(() => {
                    dispatch(
                      errorNotification({
                        hasErrorOccured: true,
                        message: t('error_message'),
                      })
                    );
                  }),
                  //Send Email to each departments' head
                  estimatedDepartment.length > 0 &&
                    estimatedDepartment.forEach(siteInfo => {
                      return fetch(`${apiConfig.uiURL}api/sendEmail`, {
                        headers: APIHeader(),
                        method: 'POST',
                        body: JSON.stringify({
                          toAddress: siteInfo.LeadEmail
                            ? siteInfo.LeadEmail
                            : '',
                          fromAddress: 'PECR@carrier.com',
                          loginUserEmail: userInfo.userEmail,
                          Title: siteInfo.Title ? siteInfo.Title : '',
                          PecrId: pecrId,
                          URL: `${url}ExecutionDepartment/${pecrId}/${siteInfo.SiteID}/${siteInfo.DeptId}/${siteInfo.EDIndex}`,
                          type: 'assignEmail',
                          toWhome: 'GC All Sites DH',
                          Comments: estimateData?.[0]?.OwnerLSCComments ?? '',
                          Departments: siteInfo.Dept ? siteInfo.Dept : '',
                          Factory: siteInfo.SiteName ? siteInfo.SiteName : '',
                          creatorsite: siteInfo.CreatorSiteName
                            ? siteInfo.CreatorSiteName
                            : '',
                          creator: `${siteInfo?.CreatorFirstName ?? ''} ${
                            siteInfo?.CreatorLastName ?? ''
                          }`,
                        }),
                      }).catch(() => {
                        dispatch(
                          errorNotification({
                            hasErrorOccured: true,
                            message: t('error_message'),
                          })
                        );
                      });
                    }),
                  uploadDocument(true)
                )
              );
            })
            .catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            })
        );
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };

  //To download the files on DownloadFilesForCostImpact API click
  const onDownloadCostImpactClick = filename => {
    fetch(`${apiConfig.uiURL}api/DownloadFilesForCostImpact`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        MainFolder: 'PECROverview',
        SubFolder: pecrId,
        siteId: siteId,
        costImpact: 'CostImpact',
        filename: filename,
      }),
    })
      .then(async response => {
        response.blob().then(blob => {
          getDownloadLink(blob, filename);
        });
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };

  //To download the files on DownloadFile API click
  const onDownloadFileClick = (
    pecrId,
    siteId,
    departmentId,
    eIndex,
    filename
  ) => {
    fetch(`${apiConfig.uiURL}api/DownloadFile`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        MainFolder: 'PECROverview',
        SubFolder: pecrId,
        siteId: siteId,
        departmentId: departmentId,
        index: eIndex,
        filename: filename,
      }),
    })
      .then(async response => {
        response.blob().then(blob => {
          getDownloadLink(blob, filename);
        });
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#1F305E',
      color: theme.palette.common.white,
      fontWeight: 'bold',
      fontSize: '17px',
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: '17px',
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(even)': {
      backgroundColor: theme.palette.action.hover,
    },
  }));

  function onCancel() {
    setShowAddDepartment(false);
  }

  async function onSave() {
    if (Object.keys(selectedDepartments).length === 0) {
      showToasterFailure(t('Please select at least one department'));
      return;
    }
    const emails = [
      ...new Set(
        Object.values(selectedDepartments)
          .filter(item => item.Email)
          .map(item => item.Email)
      ),
    ];

    await mutateAsync({
      pecrId: pecrId,
      siteId: siteId,
      phase: 'estimation',
      departments: {
        ...selectedDepartments,
      },
    });
    await sendCustomEmailMutation({
      toAddress: emails,
      fromAddress: 'PECR@carrier.com',
      subject: `You have been assigned a task to estimate on PECR ${pecrId} With Title: ${
        estimateData && estimateData[0].Title
      }`,
      body: `You have been assigned as an Estimator on PECR ${pecrId}. Please check the details in the Tracking File.`,
      link: `${url}TrackingFile?id=${pecrId}`,
    });
  }

  if (errorInAPI?.hasErrorOccured) {
    return <ErrorAlert message={errorInAPI.message} />;
  }

  if (!estimateData || !estimateData.length) {
    return (
      <Grid style={homeButtonComponent}>
        <CircularProgress />
      </Grid>
    );
  }

  const isActiveUser =
    userInfo?.active?.toString() === '1' &&
    userInfo?.userId?.toString() !== '0' &&
    Number(userInfo?.userID) === Number(estimateData[0]?.CoordinatorID) &&
    userInfo?.userId !== null;

  if (!isActiveUser) {
    return (
      <Grid style={homeButtonComponent}>{t('No_active_user_message')}</Grid>
    );
  }

  return (
    <Grid>
      {disabled && !isHold && (
        <Grid style={ReviewDoneMessage}>
          {t('This_review_has_already_done')}
        </Grid>
      )}
      <Grid style={checkboxLabel} container spacing={2}>
        <Grid item xs={8}>
          <Grid style={SiteReviewTitle}>
            <h4 style={titleName}>{t('PECR_Site_coordinator_review')}</h4>
          </Grid>
          <Grid style={SiteReviewTitle}>
            <Grid style={boldFont}>{t('Title')}:</Grid>
            <Grid style={OwnerlscValue}>
              {(estimateData &&
                estimateData[0].Title &&
                pecrId &&
                `${estimateData[0].Title}(${pecrId})`) ||
                ''}
            </Grid>
          </Grid>
          <Grid style={SiteReviewTitle}>
            <Grid style={boldFont}>{t('Description')}:</Grid>
            <Grid style={OwnerlscValue}>
              {(estimateData && estimateData[0].Description) || ''}
            </Grid>
          </Grid>
          <Grid style={SiteReviewTitle}>
            <Grid style={boldFont}>{t('Product_Family')}:</Grid>
            <Grid style={SiteReviewValue} width={1000}>
              {(estimateData &&
                estimateData[0].ProductFamily &&
                estimateData[0].ProductFamily.split(',').join(', ')) ||
                ''}
            </Grid>
          </Grid>

          <Grid style={SiteReviewTitle}>
            <Grid style={boldFont}>{t('Creator')}:</Grid>
            <Grid style={UploadedBy}>
              {(estimateData &&
                estimateData[0].CreatorFirstName &&
                estimateData[0].CreatorLastName &&
                estimateData[0].CreatorSiteName &&
                `${estimateData[0].CreatorFirstName}
                 ${estimateData[0].CreatorLastName} (${estimateData[0].CreatorSiteName})`) ||
                ''}
            </Grid>
          </Grid>
          <CreatorFiles apiConfig={apiConfig} pecrId={pecrId} />
          <Grid style={SiteReviewTitle}>
            <Grid style={boldFont}>{t('Owner')}:</Grid>
            <Grid style={UploadedBy}>
              {(estimateData &&
                estimateData[0].OwnerFirstName &&
                estimateData[0].OwnerLastName &&
                `${estimateData[0].OwnerFirstName} ${estimateData[0].OwnerLastName}`) ||
                ''}
            </Grid>
          </Grid>
          <OwnerFiles apiConfig={apiConfig} pecrId={pecrId} siteId={siteId} />

          <Grid style={SiteReviewTitle}>
            <Grid style={boldFont}>{t('Site_Name')}:</Grid>
            <Grid style={SiteReviewValue}>
              {(estimateData && estimateData[0].SiteName) || ''}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 100 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center">
                    {t('Total_Effort_Hours')}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {t('Total_Costs_Currency')}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {t('Target_date_for_execution')}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell align="center">
                    {estimateData && estimateData[0].TotalEffort
                      ? estimateData[0].TotalEffort
                      : 0}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {`${
                      (estimateData[0] && estimateData[0].TotalCost) ||
                      (estimateData[0] && estimateData[0].TotalCost === 0)
                        ? estimateData[0].TotalCost
                        : ''
                    } ${
                      estimateData[0] && estimateData[0].CurrencyUnit
                        ? estimateData[0].CurrencyUnit
                        : ''
                    }`}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {disabled ? (
                      estimateData[0] && estimateData[0].TargetDate ? (
                        estimateData[0].TargetDate
                      ) : (
                        ''
                      )
                    ) : (
                      <PickDate
                        value={selectedDate}
                        setValue={setSelectedDate}
                        disabled={disabled || !disableGCButton}
                        defaultValue={estimateData[0].TargetDate}
                      />
                    )}
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Grid style={costImpactMain} width={'100%'}>
            <Grid width={'100%'} align="center" sx={costImpactHeader}>
              {t('Cost_impact_on_products')}
            </Grid>
            <Grid width={'100%'} style={costImpactValueGrid} container>
              <Grid item xs={3} style={height30px}>
                <Grid style={homeButtonComponent}>
                  <Grid sx={{ marginRight: '3px' }} width={110}>
                    <InputTextField
                      name={'CostImpactValue'}
                      placeholder={t('Cost')}
                      style={ownerLSCInput}
                      onChange={event =>
                        handleOnChange('CostImpactOnProducts', event)
                      }
                      value={estimateData[0].CostImpactOnProducts}
                      type={'number'}
                      disabled={disabled || !disableGCButton}
                      onKeyDown={e =>
                        includeNegativeForCostImpact.includes(e.key) &&
                        e.preventDefault()
                      }
                    />
                  </Grid>
                  <Grid>
                    {estimateData[0] && estimateData[0].CurrencyUnit
                      ? estimateData[0].CurrencyUnit
                      : ''}
                  </Grid>
                </Grid>
              </Grid>
              <Divider
                orientation="vertical"
                flexItem
                sx={{ backgroundColor: 'black' }}
              />
              <Grid item xs={8} style={costImpactdisplayFiles}>
                {disabled ? (
                  displayFiles && displayFiles.length > 0 ? (
                    <>
                      <Grid style={UploadedDocument}>
                        {t('Uploaded_Document')}:
                      </Grid>
                      <Grid style={uploadedFilesGrid}>
                        <Grid style={UploadedDocument}>
                          {displayFiles.map((document, index) => {
                            return (
                              <Tooltip
                                key={index}
                                title={document}
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      fontSize: '14px',
                                    },
                                  },
                                }}
                              >
                                <Typography
                                  key={index}
                                  noWrap
                                  width={400}
                                  style={TextAsLink}
                                  onClick={() =>
                                    onDownloadCostImpactClick(document)
                                  }
                                >
                                  {document}
                                </Typography>
                              </Tooltip>
                            );
                          })}
                        </Grid>
                      </Grid>
                    </>
                  ) : (
                    <>
                      <Grid style={UploadedDocument}>
                        {t('Uploaded_Document')}:
                      </Grid>
                      {t('No_files_have_been_uploaded')}
                    </>
                  )
                ) : (
                  <FileUpload
                    displayFiles={displayFiles}
                    setDisplayFiles={setDisplayFiles}
                    uploadedFiles={uploadedFiles}
                    setUploadedFiles={setUploadedFiles}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                    removeDoc={removeDoc}
                    disabled={disabled || !disableGCButton}
                    isOwnerLSC={true}
                    marginLeft={'0rem'}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid style={SiteReviewTitle}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 100 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell align="center"></StyledTableCell>
                <StyledTableCell align="center">
                  {t('Department')}
                </StyledTableCell>
                <StyledTableCell align="center">{t('Status')}</StyledTableCell>
                <StyledTableCell align="center">{t('Lead')}</StyledTableCell>
                <StyledTableCell align="center">{t('Date')}</StyledTableCell>
                <StyledTableCell align="center">
                  {t('Effort_Hours')}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {t('Costs_Currency')}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {t('Comments')}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {t('Attachements')}
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {estimateData.map((data, index) => {
                const checked = selectedCheckbox.some(list => {
                  return list.Dept === data.Dept;
                });
                const disableCheckboxForInProgressDept =
                  data.StatusName === 'Estimating in process';
                return (
                  <StyledTableRow key={index}>
                    <StyledTableCell align="center">
                      <Checkbox
                        onChange={() => handleCheckboxChange(data)}
                        checked={checked}
                        disabled={disabled || disableCheckboxForInProgressDept}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data && data.Dept ? data.Dept : ''}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data && data.StatusName ? data.StatusName : ''}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {`${
                        data && data.LeadFirstName ? data.LeadFirstName : ''
                      } ${data && data.LeadLastName ? data.LeadLastName : ''}`}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data && data.EstimatedDate ? data.EstimatedDate : ''}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {(data && data.EstimatedEffort) ||
                      (data && data.EstimatedEffort === 0)
                        ? data.EstimatedEffort
                        : ''}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {`${
                        (data && data.EstimatedCost) ||
                        (data && data.EstimatedCost === 0)
                          ? data.EstimatedCost
                          : ''
                      } ${data && data.CurrencyUnit ? data.CurrencyUnit : ''}`}
                    </StyledTableCell>
                    <StyledTableCell align="center" width={'fit'}>
                      <Tooltip
                        title={
                          data && data.EstimatedComment
                            ? data.EstimatedComment
                            : ''
                        }
                        componentsProps={{
                          tooltip: {
                            sx: {
                              fontSize: '14px',
                            },
                          },
                        }}
                      >
                        <Typography
                          noWrap
                          width={300}
                          sx={{
                            cursor: 'default',
                            margin: 'auto',
                            fontSize: '14px',
                            maxHeight: '100px',
                            overflow: 'auto',
                            wordWrap: 'break-word',
                            whiteSpace: 'pre-wrap',
                            '&::-webkit-scrollbar': {
                              width: '6px',
                            },
                            '&::-webkit-scrollbar-track': {
                              backgroundColor: '#f1f1f1',
                              borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                              backgroundColor: '#c1c1c1',
                              borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                              backgroundColor: '#a8a8a8',
                            },
                          }}
                        >
                          {data && data.EstimatedComment
                            ? data.EstimatedComment
                            : ''}
                        </Typography>
                      </Tooltip>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data && data.Doc && data.Doc.length > 0
                        ? data.Doc.map((document, id) => {
                            return (
                              <Tooltip
                                key={id}
                                title={document}
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      fontSize: '14px',
                                    },
                                  },
                                }}
                              >
                                <Typography
                                  key={id}
                                  noWrap
                                  width={300}
                                  style={TextAsLink}
                                  onClick={() =>
                                    onDownloadFileClick(
                                      data.PECR_ID,
                                      data.SiteID,
                                      data.DeptId,
                                      data.EDIndex,
                                      document
                                    )
                                  }
                                >
                                  {document}
                                </Typography>
                              </Tooltip>
                            );
                          })
                        : ''}
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Grid style={OwnerLSCComment}>
        <InputTextAreaField
          name={'OwnerLSCComment'}
          placeholder={!disabled ? t('Add_Comments_here') : ''}
          onChange={event => handleOnChange('OwnerLSCComments', event)}
          customStyle={commentStyle}
          value={estimateData[0].OwnerLSCComments}
          disabled={disabled}
        />
      </Grid>
      <Grid style={validationErrorOnPages}>{inputValidationMessage}</Grid>
      <Toast />
      <Grid style={LocalSiteButtons}>
        <Button
          title={t('Provide_new_estimates')}
          onClick={onProvideNewEstimatesClick}
          disabled={
            !(selectedCheckbox.length > 0) || inputValidationMessage !== ''
          }
        />
        <Button
          title={t('Add Department')}
          onClick={onAddNewDepartment}
          disabled={disabled}
        />
        <Activity mode={showAddDepartment ? 'visible' : 'hidden'}>
          <AddDepartment>
            <AddDepartment.Header title={t('Add Department')} />
            <AddDepartment.Departments
              siteId={siteId}
              pecrId={pecrId}
              setSelectedDepartments={setSelectedDepartments}
              selectedDepartments={selectedDepartments}
              estimateData={estimateData}
            />
            <AddDepartment.ButtonRow>
              <CustomButton
                message="Cancel"
                type="cancel"
                size="medium"
                onClick={onCancel}
              />
              <CustomButton
                message="Save"
                type="primary"
                size="medium"
                onClick={onSave}
              />
            </AddDepartment.ButtonRow>
          </AddDepartment>
        </Activity>
        <Button
          title={t('Reject')}
          onClick={onRejectClick}
          disabled={
            disabled || !disableGCButton || inputValidationMessage !== ''
          }
        />

        {isHold ? (
          <Button title={t('Un_Hold')} onClick={onUnHoldClick} />
        ) : (
          <Button
            title={t('Hold')}
            onClick={onHoldClick}
            disabled={
              disabled ||
              estimateData[0].OwnerLSCComments === '' ||
              estimateData[0].OwnerLSCComments === null ||
              !disableGCButton ||
              inputValidationMessage !== ''
            }
          />
        )}
        <Grid sx={{ position: 'relative' }}>
          <Button
            title={t('Save')}
            onClick={onSaveClick}
            disabled={
              disabled ||
              inputValidationMessage !== '' ||
              showSaveProgress ||
              !disableGCButton
            }
          />
          {showSaveProgress && (
            <CircularProgress size={28} sx={buttonCircularProgress} />
          )}
        </Grid>
        {estimateData[0].Sites === 'Single' ? (
          <Button
            title={t('Execute')}
            onClick={onExecuteClick}
            disabled={
              disabled ||
              !targetDate ||
              !disableGCButton ||
              !(
                estimatedDepartment.length > 0 ||
                notImapctedDepartments.length > 0
              ) ||
              disableGCExecuteButton ||
              inputValidationMessage !== ''
            }
          />
        ) : (
          <Button
            title={t('Submit_to_global_coordinator')}
            onClick={onSubmitToGCClick}
            disabled={
              disabled ||
              !targetDate ||
              !disableGCButton ||
              !(
                estimatedDepartment.length > 0 ||
                notImapctedDepartments.length > 0
              ) ||
              disableGCExecuteButton ||
              inputValidationMessage !== ''
            }
          />
        )}
      </Grid>
      {showProgress && (
        <Grid style={progressBar}>
          <LinearProgress color="success" sx={{ padding: '5px' }} />
        </Grid>
      )}
    </Grid>
  );
};

const mapStateToProps = (state = {}) => {
  return {
    userInfo: state.userInfo,
    errorInAPI: state.errorNotification,
  };
};

export default connect(mapStateToProps, null)(OwnerLSCReview);
